// for shared getters, mutations, actions ...
import {
    SET_LOADING,
    SET_ERROR,
    CLEAR_ERROR,
    SET_SUCCESS,
    SET_SWIPPER
} from '../../mutation-types';

export default {
    state: {
        loading: false,
        error: null,
        success: null,
        showNotification: false,
        level: '',
        message: '',
        swipping: false,
        paginate: false,
        pagination: {},
        lng: '',
        lat: '',
    },

    mutations: {
        [SET_LOADING](state, payload) {
            state.loading = payload
        },
        [SET_ERROR](state, payload) {
            state.error = payload
        },
        [CLEAR_ERROR](state) {
            state.error = null
        },
        [SET_SUCCESS](state, payload) {
            state.success = payload
        },
        setNotification(state, payload) {
            state.showNotification = payload.showNotification;
            state.message = payload.message;
            state.level = payload.level;
        },
        clearNotification(state) {
            state.showNotification = false;
            state.message = '';
            state.level = '';
        },

        [SET_SWIPPER](state, payload) {
            // console.log('set swipper store: ' , state, payload);
            state.swipping = payload;
        },

        setPaginate(state, payload) {
            // console.log('setPaginate', state, payload);
            state.paginate = true;
        },

        setPagination(state, payload) {
            // console.log('setPagination: ', payload);
            // payload.delete(data);
            // state.pagination = payload;
            state.pagination = {
                current_page: payload.current_page,
                first_page_url: payload.first_page_url,
                last_page_url: payload.last_page_url,
                prev_page_url: payload.prev_page_url,
                next_page_url: payload.next_page_url,
                path: payload.path,
                from: payload.from,
                to: payload.to,
                total: payload.total,
                per_page: payload.per_page,
                last_page: payload.last_page,
            };
        },

        setPaginationCurrentPage(state, payload) {
            state.pagination.current_page = payload;
        },

        setLat(state, payload) {
            // console.log('SET lag: ', payload);
            state.lat = payload;
        },

        setLng(state, payload) {
            // console.log('SET lng: ', payload);
            state.lng = payload;
        },
    },

    getters: {
        showNotification: state => state.showNotification,
        level: state => state.level,
        message: state => state.message,
        swipping: state => state.swipping,
        // error: state => state.error,
        error (state) {
            // console.log('SHARED STORE - getters error: ', state);
            return state.error;
        },
        success (state) {
            return state.success;
        },
        // loading: state => state.loading,
        loading (state) {
            // console.log('SHARED STORE - getters loading: ', state);
            return state.loading;
        },
        paginate: state => state.paginate,
        pagination: state => state.pagination,
        lat (state) {
            // console.log('getters lat: ', state.lat);
            return state.lat;
        },
        lng (state) {
            // console.log('getters lng: ', state.lng);
            return state.lng;
        },
    },

    actions: {
        setLat({commit}, payload) {
            commit('setLat', payload);
        },

        setLng({commit}, payload) {
            commit('setLng', payload);
        },

        setPaginationCurrentPage({commit}, payload) {
            commit('setPaginationCurrentPage', payload);
        },
        setLoading({commit}, payload) {
            // console.log('SHARED STORE action setLoading: ', payload);
            commit(SET_LOADING, payload);
        },

        setError({commit}, payload) {
            // console.log('SHARED STORE action setError: ', payload);
            commit(SET_ERROR, payload);
        },

        setSuccess({commit}, payload) {
            commit(SET_SUCCESS, payload);
        },

        clearError({ commit }, field) {
            // console.log('SHARED STORE Action clear error: ', field);
            if (field !== null || field !== undefined) {
                // delete this.error[field];

                // return;
            }
            commit(CLEAR_ERROR)
        },

        setNotification({commit}, payload) {
            commit('setNotification', payload);
        },

        clearNotification({commit}) {
            commit('clearNotification');
        },

        setSwipper({commit}, payload) {
            // console.log('set swipper action: ', payload, commit);
            commit(SET_SWIPPER, payload);
        },
    }
};



// WEBPACK FOOTER //
// ./src/store/modules/shared/index.js